import { TYPES } from "@actions/address-actions";
import INITIAL_STATE from "./initial-state";

const addressesReducer = (state = INITIAL_STATE.address, action) => {
  switch (action.type) {
    case TYPES.SET_ADDRESSES:
      return {
        ...state,
        addresses: action.addresses,
      };
    case TYPES.SET_ADDRESSES_LOADING:
      return {
        ...state,
        areAddressesLoading: action.isLoading,
      };
    default:
      return state;
  }
};

export default addressesReducer;
